import { render, staticRenderFns } from "./PowerGuard.vue?vue&type=template&id=593ac983&scoped=true"
import script from "./PowerGuard.vue?vue&type=script&lang=js"
export * from "./PowerGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ac983",
  null
  
)

export default component.exports